export const VividSeatsOrderNotificationsEmail = 'orders@coe.vividseats.com';
